(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Counts numbers like "3%" or "100%" up from 0 (text such as "Libre" is left alone)
  function countUp(el){
    if (el.getAttribute('data-es-counted')) return;
    var m = (el.textContent || '').trim().match(/^(\D*?)(\d+(?:[.,]\d+)?)(\D*)$/);
    if (!m) return;
    el.setAttribute('data-es-counted', '1');
    var target = parseFloat(m[2].replace(',', '.'));
    if (!(target > 0) || reduce) return;
    var dec = (m[2].split(/[.,]/)[1] || '').length;
    var start = null, dur = 1400;
    function step(t){
      if (start === null) start = t;
      var p = Math.min((t - start) / dur, 1);
      var v = target * (1 - Math.pow(1 - p, 4));
      el.textContent = m[1] + v.toFixed(dec) + m[3];
      if (p < 1) requestAnimationFrame(step); else el.textContent = m[1] + m[2] + m[3];
    }
    el.textContent = m[1] + (0).toFixed(dec) + m[3];
    requestAnimationFrame(step);
  }

  function reveal(el){
    el.classList.add('es-visible');
    if (el.hasAttribute('data-es-stagger')) {
      var n = el.children.length;
      setTimeout(function(){ el.classList.add('es-settled'); }, n * 90 + 1100);
      Array.prototype.forEach.call(el.querySelectorAll('.es-trust__num'), countUp);
    }
  }

  function init(root){
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-es-stagger]'), function(p){
      Array.prototype.forEach.call(p.children, function(c, i){ c.style.setProperty('--es-i', i); });
    });
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-es-animate]:not(.es-visible),[data-es-stagger]:not(.es-visible)'));
    if (!('IntersectionObserver' in window)) { els.forEach(reveal); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { reveal(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });

  // Gold glow that follows the cursor on cards
  document.addEventListener('pointermove', function(e){
    var card = e.target.closest && e.target.closest('.es-feature-card,.es-prop-card');
    if (!card) return;
    var r = card.getBoundingClientRect();
    card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    card.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  var skySecs = ['es-trust-bar', 'es-for-sellers', 'es-properties']
    .map(function(id){ return document.getElementById(id); })
    .filter(Boolean);

  // ---- Cloud texture generator (runs inside a Web Worker) ----
  // Seamless, tileable soft cumulus clouds with alpha: periodic spectral noise (FFT),
  // periodic domain warp, light-from-above shading. Deterministic for a given seed.
  function skyWorker(){
    self.onmessage = function(e){
      var W = e.data.w, H = e.data.h, N = W * H;
      var seed = e.data.seed >>> 0;
      function rnd(){
        seed = (seed + 0x6D2B79F5) | 0;
        var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      function fft(re, im, n){
        for (var i = 1, j = 0; i < n; i++){
          var bit = n >> 1;
          for (; j & bit; bit >>= 1) j ^= bit;
          j ^= bit;
          if (i < j){ var t = re[i]; re[i] = re[j]; re[j] = t; t = im[i]; im[i] = im[j]; im[j] = t; }
        }
        for (var len = 2; len <= n; len <<= 1){
          var ang = 2 * Math.PI / len, wr = Math.cos(ang), wi = Math.sin(ang), half = len >> 1;
          for (var s = 0; s < n; s += len){
            var cr = 1, ci = 0;
            for (var k = 0; k < half; k++){
              var a = s + k, b = a + half;
              var xr = re[b] * cr - im[b] * ci, xi = re[b] * ci + im[b] * cr;
              re[b] = re[a] - xr; im[b] = im[a] - xi; re[a] += xr; im[a] += xi;
              var ncr = cr * wr - ci * wi; ci = cr * wi + ci * wr; cr = ncr;
            }
          }
        }
      }
      function ifft2(re, im){
        var rr = new Float64Array(W), ri = new Float64Array(W), x, y;
        for (y = 0; y < H; y++){
          var o = y * W;
          for (x = 0; x < W; x++){ rr[x] = re[o + x]; ri[x] = im[o + x]; }
          fft(rr, ri, W);
          for (x = 0; x < W; x++){ re[o + x] = rr[x]; im[o + x] = ri[x]; }
        }
        var cr = new Float64Array(H), ci = new Float64Array(H);
        for (x = 0; x < W; x++){
          for (y = 0; y < H; y++){ cr[y] = re[y * W + x]; ci[y] = im[y * W + x]; }
          fft(cr, ci, H);
          for (y = 0; y < H; y++){ re[y * W + x] = cr[y]; im[y * W + x] = ci[y]; }
        }
      }
      function norm(a){
        var m = 0, v = 0, i;
        for (i = 0; i < N; i++) m += a[i];
        m /= N;
        for (i = 0; i < N; i++){ a[i] -= m; v += a[i] * a[i]; }
        v = Math.sqrt(v / N) || 1;
        for (i = 0; i < N; i++) a[i] /= v;
        return a;
      }
      function freq(k, n){ return (k < n / 2 ? k : k - n) / n; }
      function noise(beta, hicut, stretch){
        var re = new Float64Array(N), im = new Float64Array(N);
        for (var y = 0; y < H; y++){
          var fy = freq(y, H);
          for (var x = 0; x < W; x++){
            var fx = freq(x, W) * stretch, f = Math.sqrt(fx * fx + fy * fy), i = y * W + x;
            if (f === 0) continue;
            var amp = Math.pow(f, -beta / 2) * Math.exp(-(f / hicut) * (f / hicut));
            var ph = rnd() * 2 * Math.PI;
            re[i] = amp * Math.cos(ph); im[i] = amp * Math.sin(ph);
          }
        }
        ifft2(re, im);
        return [norm(re), norm(im)];
      }
      function boxBlurWrap(src, r){
        var tmp = new Float64Array(N), out = new Float64Array(N), x, y, k, s, d = 2 * r + 1;
        for (y = 0; y < H; y++){
          var o = y * W;
          for (x = 0; x < W; x++){
            s = 0;
            for (k = -r; k <= r; k++) s += src[o + ((x + k + W) % W)];
            tmp[o + x] = s / d;
          }
        }
        for (x = 0; x < W; x++){
          for (y = 0; y < H; y++){
            s = 0;
            for (k = -r; k <= r; k++) s += tmp[((y + k + H) % H) * W + x];
            out[y * W + x] = s / d;
          }
        }
        return out;
      }

      var sc = e.data.scale;                      // texture px -> display px
      var hicut = 0.03 * sc, warp = 45 / sc;
      var base = noise(3.2, hicut, 1.8)[0];
      var detail = noise(2.2, hicut * 2.5, 1.3)[0];
      var w2 = noise(3.8, hicut * 0.7, 1.8), wx = w2[0], wy = w2[1];

      // domain-warped field (bilinear, wrapping)
      var n = new Float64Array(N), x, y, i;
      for (y = 0; y < H; y++){
        for (x = 0; x < W; x++){
          i = y * W + x;
          var sx = x + warp * wx[i], sy = y + warp * 0.4 * wy[i];
          var x0 = Math.floor(sx), y0 = Math.floor(sy), fx = sx - x0, fy = sy - y0;
          x0 = ((x0 % W) + W) % W; y0 = ((y0 % H) + H) % H;
          var x1 = (x0 + 1) % W, y1 = (y0 + 1) % H;
          n[i] = base[y0 * W + x0] * (1 - fx) * (1 - fy) + base[y0 * W + x1] * fx * (1 - fy)
               + base[y1 * W + x0] * (1 - fx) * fy + base[y1 * W + x1] * fx * fy
               + 0.28 * detail[i];
        }
      }
      // threshold so about a third of the tile is cloud (histogram quantile)
      var lo = Infinity, hi = -Infinity;
      for (i = 0; i < N; i++){ if (n[i] < lo) lo = n[i]; if (n[i] > hi) hi = n[i]; }
      var B = 4096, hist = new Uint32Array(B), bw = (hi - lo) / B;
      for (i = 0; i < N; i++) hist[Math.min(B - 1, ((n[i] - lo) / bw) | 0)]++;
      var target = N * 0.34, acc = 0, b = B - 1;
      for (; b > 0; b--){ acc += hist[b]; if (acc >= target) break; }
      var thr = lo + b * bw, soft = 0.9, e0 = thr - soft * 0.2, e1 = thr + soft;

      var dens = new Float64Array(N);
      for (i = 0; i < N; i++){
        var t = Math.min(1, Math.max(0, (n[i] - e0) / (e1 - e0)));
        dens[i] = Math.pow(t * t * (3 - 2 * t), 1.3);
      }
      // light from above: accumulate density above each pixel -> soft gray undersides
      var br = Math.max(1, Math.round(6.4 / sc)), bl = boxBlurWrap(boxBlurWrap(dens, br), br);
      var step = Math.max(2, Math.round(11.5 / sc)), steps = 14;
      var px = new Uint8ClampedArray(N * 4);
      for (y = 0; y < H; y++){
        for (x = 0; x < W; x++){
          i = y * W + x;
          var a2 = 0;
          for (var k = 1; k <= steps; k++){
            var yy = (((y - k * step) % H) + H) % H;
            a2 += bl[yy * W + x] * (1 - k / (steps + 1));
          }
          a2 /= steps * 0.5;
          var d = dens[i];
          var sh = Math.min(0.5, Math.max(0, 0.45 * a2));
          var r = 255 * (1 - sh) + 194 * sh, g = 255 * (1 - sh) + 209 * sh, bb = 255 * (1 - sh) + 226 * sh;
          var rim = Math.max(0, Math.min(1, d - a2 * 0.9)) * Math.max(0, Math.min(1, 1 - a2 * 1.5));
          var rr = Math.min(0.4, rim * 0.5);
          r = r * (1 - rr) + 255 * rr; g = g * (1 - rr) + 244 * rr; bb = bb * (1 - rr) + 224 * rr;
          var o4 = i * 4;
          px[o4] = r; px[o4 + 1] = g; px[o4 + 2] = bb; px[o4 + 3] = Math.min(1, d * 0.97) * 255;
        }
      }
      self.postMessage({ px: px, w: W, h: H }, [px.buffer]);
    };
  }

  // Builds (or reads from cache) the cloud texture and exposes it as --es-sky-img
  function loadSkyTexture(){
    var small = window.innerWidth <= 768, size = small ? 512 : 1024;
    var KEY = 'es-sky-v1-' + size, root = document.documentElement;
    function apply(url){
      root.style.setProperty('--es-sky-img', 'url("' + url + '")');
      requestAnimationFrame(function(){ root.classList.add('es-sky-ready'); });
    }
    try { var cached = localStorage.getItem(KEY); if (cached) { apply(cached); return; } } catch (err) {}
    function generate(){
      var worker;
      try {
        var src = '(' + skyWorker.toString() + ')()';
        worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
      } catch (err) { return; }
      worker.onmessage = function(e){
        worker.terminate();
        var c = document.createElement('canvas');
        c.width = e.data.w; c.height = e.data.h;
        c.getContext('2d').putImageData(new ImageData(e.data.px, e.data.w, e.data.h), 0, 0);
        c.toBlob(function(blob){
          if (!blob) return;
          apply(URL.createObjectURL(blob));
          if (blob.type === 'image/webp' && blob.size < 400000) {
            var fr = new FileReader();
            fr.onload = function(){ try { localStorage.setItem(KEY, fr.result); } catch (err) {} };
            fr.readAsDataURL(blob);
          }
        }, 'image/webp', 0.82);
      };
      worker.postMessage({ w: size, h: size, seed: 3, scale: (small ? 1000 : 1600) / size });
    }
    if (document.readyState === 'complete') setTimeout(generate, 200);
    else window.addEventListener('load', function(){ setTimeout(generate, 200); });
  }

  // Sky: add the cloud layers, keep them continuous across the three sections + gentle scroll parallax
  (function initSky(){
    if (!skySecs.length) return;
    skySecs.forEach(function(s){
      if (s.querySelector('.es-sky')) return;
      var sky = document.createElement('div');
      sky.className = 'es-sky';
      sky.setAttribute('aria-hidden', 'true');
      sky.innerHTML = '<div class="es-sky__layer es-sky__layer--far"></div><div class="es-sky__layer es-sky__layer--near"></div>';
      s.insertBefore(sky, s.firstChild);
    });
    loadSkyTexture();
    function measure(){
      var top0 = skySecs[0].getBoundingClientRect().top;
      skySecs.forEach(function(s){
        s.style.setProperty('--sky-top', Math.round(s.getBoundingClientRect().top - top0) + 'px');
      });
    }
    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      skySecs.forEach(function(s){ ro.observe(s); });
    }
    if (reduce) return;
    var far = [], near = [];
    skySecs.forEach(function(s){
      var f = s.querySelector('.es-sky__layer--far'), n = s.querySelector('.es-sky__layer--near');
      if (f) far.push(f);
      if (n) near.push(n);
    });
    if (!far.length && !near.length) return;
    var ticking = false;
    function clamp(v){ return Math.max(-200, Math.min(200, v)); }
    function update(){
      ticking = false;
      var prog = -skySecs[0].getBoundingClientRect().top; // px scrolled past the top of the trust bar
      var yN = clamp(prog * -0.08).toFixed(1), yF = clamp(prog * 0.05).toFixed(1);
      near.forEach(function(el){ el.style.translate = '0 ' + yN + 'px'; });
      far.forEach(function(el){ el.style.translate = '0 ' + yF + 'px'; });
    }
    window.addEventListener('scroll', function(){
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  // Interactive background from the trust bar down to the houses.
  // All three sections light up together and each draws the light at the same
  // screen point, so the glow crosses section borders with no visible seam.
  (function initBg(){
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine || reduce || !skySecs.length) return;
    var els = skySecs;
    els.forEach(function(el){ el.classList.add('es-bg-interactive'); });

    var tx = 0, ty = 0, cx = 0, cy = 0, active = false, raf = null;
    function paint(){
      cx += (tx - cx) * 0.15;
      cy += (ty - cy) * 0.15;
      els.forEach(function(el){
        var r = el.getBoundingClientRect();
        el.style.setProperty('--bx', (cx - r.left).toFixed(1) + 'px');
        el.style.setProperty('--by', (cy - r.top).toFixed(1) + 'px');
      });
      raf = (Math.abs(tx - cx) > 0.3 || Math.abs(ty - cy) > 0.3) ? requestAnimationFrame(paint) : null;
    }
    function kick(){ if (!raf) raf = requestAnimationFrame(paint); }
    function setActive(on){
      if (on === active) return;
      active = on;
      els.forEach(function(el){ el.classList.toggle('es-bg-active', on); });
    }

    document.addEventListener('pointermove', function(e){
      var inside = els.some(function(el){ return el.contains(e.target); });
      tx = e.clientX; ty = e.clientY;
      if (inside && !active) { cx = tx; cy = ty; }
      setActive(inside);
      if (inside) kick();
    }, { passive: true });
    window.addEventListener('scroll', function(){ if (active) kick(); }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function(){ setActive(false); });
  })();

  // Sticky WhatsApp bar slides in after scrolling
  var bar = document.getElementById('es-sticky-wa');
  if (bar) {
    var shown = false;
    window.addEventListener('scroll', function(){
      if (window.scrollY > 300 && !shown) {
        bar.classList.add('es-sticky-wa--visible');
        shown = true;
      }
    }, { passive: true });
  }
})();
